// Update the field warning without preventing input.
export function checkForWarning(component, field, value) {
    const invalid = value != null && String(value).replace(/[^a-zA-Z0-9./_-]/g, '') !== String(value)
    const warning = invalid
        ? `Invalid ${field}. Only English letters, numbers and . / _ - are allowed; spaces are not allowed.`
        : ''

    component.setState(state => ({
        queryWarnings: {...state.queryWarnings, [field]: warning}
    }))
    return invalid
}
